import React, { useReducer } from 'react'

export default function useToggler(initial: boolean = false) {
  const [flag, toggle] = useReducer((prev: boolean, next = !prev) => next, initial)

  return [flag, toggle] as [boolean, (...args: [boolean?]) => void]
}
